<template>
  <Bilde :value="data" :variables="variables" />
</template>

<script>
import Bilde from "./Bilde";

export default {
  props: {
    value: Object,
    variables: Object,
  },
  computed: {
    content() {
      let res = { Bilde: { url: null }, BildeMobil: { url: null } };
      let val = this.variables[this.value.Variabel];

      if (typeof val === "string") res.Bilde.url = val;
      if (typeof val === "object") {
        res.Bilde.url = val.default;
        res.BildeMobil.url = val.mobile;
      }

      return res;
    },
    data() {
      return {
        ...this.content,
        Caption: this.value.Caption,
        Caption_eng: this.value.Caption_eng,
      };
    },
  },
  components: {
    Bilde,
  },
};
</script>
